import Vue from 'vue';
import App from './App.vue';
import store from './store';
import VueRouter from 'vue-router';
import vuetify from './plugins/vuetify';
import { routes } from './routes';
import axios from 'axios';
import VueMask from 'v-mask'
import VueCurrencyInput from 'vue-currency-input'
 
Vue.use(VueCurrencyInput)
// var mercadopago = require('mercadopago');
// console.log("M",mercadopago);
// axios.defaults.baseURL = 'https://portal.yoomy.mx/restapi_test/v1/';

if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = 'https://portal.yoomy.mx/restapi/v1/';
} else {
  axios.defaults.baseURL = 'https://portal.yoomy.mx/restapi_test/v1/';
  console.log(`%c Entorno actual: ${process.env.NODE_ENV}`, 'color: teal; font-weight: bold;');
  console.log(`%c Base URL: ${axios.defaults.baseURL}`, 'color: teal; font-weight: bold;');
}

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: 'history'
});

Vue.config.productionTip = false
Vue.use(VueMask);

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
